import rearrange from "../../../../assets/videos/docs/panes/rearrange.mp4";
import * as React from 'react';
export default {
  rearrange,
  React
};